export enum TransferVehicleType {
  OTOMOBIL = 'Otomobil',
  MINI_S = 'MiniS',
  MINIBUS = 'Minibus',
  VIP = 'Vip',
  MIDIBUS = 'Midibus',
  ECO_TRANSFER = 'EcoTransfer',
  MASTER_CARD_FREE_VIP_TRANSFER = 'MasterCardFreeVipTransfer',
  FREE_TRANSFER = 'FreeTransfer',
  BUS = 'Bus',
  SPEEDY_ECO_TRANSFER = 'SpeedyEcoTransfer',
}
